"use client";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import React, { useCallback } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { getGlobalLookup } from "../globals/lookup";
import { messageToGibberish } from "./gibberish";
import { LocalizationStore } from "./LocalizationStore";
export { localNum } from "./localNum";
export { useLocalNum } from "./useLocalNum";
export var StrictBaseLocalMsg = function StrictBaseLocalMsg(props) {
  var defaultMessage = props.defaultMessage,
    description = props.description,
    values = props.values,
    id = props.id;
  var _LocalizationStore$ge = LocalizationStore.get(),
    localeKey = _LocalizationStore$ge.localeKey;
  if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID) {
    return /*#__PURE__*/React.createElement(FormattedMessage
    // eslint-disable-next-line @faire/enforce-default-message-formatjs
    , {
      // eslint-disable-next-line @faire/enforce-default-message-formatjs
      defaultMessage: id,
      id: id
    });
  }
  if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
    return /*#__PURE__*/React.createElement(FormattedMessage
    // eslint-disable-next-line @faire/enforce-default-message-formatjs
    , {
      // eslint-disable-next-line @faire/enforce-default-message-formatjs
      defaultMessage: messageToGibberish(defaultMessage),
      description: description,
      // Any default chunks should be defined using wrappers in the consuming repository
      // this is because updates to defaults need to be included in the eslintrc for that project
      values: values,
      id: id
    });
  }
  return /*#__PURE__*/React.createElement(FormattedMessage
  // eslint-disable-next-line @faire/enforce-default-message-formatjs
  , {
    // eslint-disable-next-line @faire/enforce-default-message-formatjs
    defaultMessage: defaultMessage,
    description: description,
    // Any default chunks should be defined using wrappers in the consuming repository
    // this is because updates to defaults need to be included in the eslintrc for that project
    values: values,
    id: id
  });
};
/**
 * @deprecated
 * Replace with `DEPRECATED_backwardsCompatibleValues`.
 * This should NOT be used in new code.
 *
 * This was used to migrate from localize -> strictLocalize and LocalMsg -> StrictLocalMsg to force values objects to align and should not be used anymore
 * */
export var backwardsCompatibleValues = function backwardsCompatibleValues(values) {
  return values;
};
/**
 * This should NOT be used in new code.
 *
 * This was used to migrate from localize -> strictLocalize and LocalMsg -> StrictLocalMsg to force values objects to align and should not be used anymore
 * */
export var DEPRECATED_backwardsCompatibleValues = function DEPRECATED_backwardsCompatibleValues(values) {
  return values;
};
/**
 * @deprecated
 * @trackfunction
 * Access `strictLocalize` using `useStrictLocalize` (or `withStrictLocalize` for class components) instead.
 */
export var strictLocalize = function strictLocalize(descriptor, values, opts) {
  return LocalizationStore.get().intl.formatMessage(descriptor, values, opts);
};
export var useStrictLocalization = function useStrictLocalization() {
  var intl = useIntl();
  var _LocalizationStore$ge2 = LocalizationStore.get(),
    legacyIntl = _LocalizationStore$ge2.intl,
    localeKey = _LocalizationStore$ge2.localeKey;
  var strictLocalize = useCallback(function (descriptor, values, opts) {
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID) {
      var _descriptor$id;
      return (_descriptor$id = descriptor.id) !== null && _descriptor$id !== void 0 ? _descriptor$id : "";
    }
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
      return intl.formatMessage({
        // eslint-disable-next-line @faire/enforce-default-message-formatjs
        defaultMessage: messageToGibberish(descriptor.defaultMessage),
        id: descriptor.id
      }, values, opts);
    }
    return intl.formatMessage(
    /**
     * react-intl uses a different formatjs version than us.
     * The descriptor types don't perfectly match, but it should work fine.
     */
    descriptor, values, opts);
  }, [intl, localeKey === null || localeKey === void 0 ? void 0 : localeKey.language]);
  var legacyStrictLocalize = useCallback(function (descriptor, values, opts) {
    return legacyIntl.formatMessage(descriptor, values, opts);
  }, [legacyIntl]);
  // Return the named function for babel string extraction
  var lookup = getGlobalLookup();
  return {
    strictLocalize: lookup("isNextJS") ? strictLocalize : legacyStrictLocalize
  };
};
export var withStrictLocalization = function withStrictLocalization(Component) {
  var ComponentWithStrictLocalization = function ComponentWithStrictLocalization(props) {
    var strictLocalizationProps = useStrictLocalization();
    return /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({}, props), strictLocalizationProps));
  };
  return ComponentWithStrictLocalization;
};